module.exports = __webpack_public_path__ + "front/img/sub-img-4.3514ead7.png";